// import { alpha, createTheme, makeStyles } from "@material-ui/core";
import { alpha, createTheme } from '@mui/material';
// import backgroundImage from '../assets/fondo1.jpg';
import backgroundImage from '../assets/fondo2.png';
import { makeStyles } from '@mui/styles';

const drawerWidth = 240;

// ============================================
// PALETA DE COLORES ALIANZA SOCIAL  
// ============================================
const alianzaColors = {
  primary: {
    main: '#1E88E5',
    light: '#64B5F6',
    dark: '#1565C0',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#E63946',
    light: '#FF6B6B',
    dark: '#C62828',
    contrastText: '#FFFFFF',
  },
  accent: {
    yellow: '#FFC107',
    orange: '#FF9800',
    green: '#4CAF50',
    purple: '#9C27B0',
  },
  neutral: {
    darkGrey: '#424242',
    mediumGrey: '#757575',
    lightGrey: '#BDBDBD',
    background: '#F5F5F5',
    white: '#FFFFFF',
  },
};

// ============================================
// PALETA DE COLORES CAPELLANES
// ============================================
const capellanesColors = {
  // Colores primarios
  gold: '#D4AF37',
  lightGold: '#F4E4BC',
  darkGold: '#B8960C',
  
  // Colores neutros
  black: '#1A1A1A',
  darkGrey: '#2D2D2D',
  white: '#FFFFFF',
  offWhite: '#F8F6F0',
  cream: '#FDF8E8',
  
  // Colores de estado
  error: '#E63946',
  success: '#4CAF50',
  warning: '#FF9800',
  info: '#2196F3',
};

const theme = createTheme({
    palette: {
      // Colores principales de Alianza Social
      primary: {
        light: alianzaColors.primary.light,
        main: alianzaColors.primary.main,
        dark: alianzaColors.primary.dark,
        contrastText: alianzaColors.primary.contrastText,
      },
      secondary: {
        light: alianzaColors.secondary.light,
        main: alianzaColors.secondary.main,
        dark: alianzaColors.secondary.dark,
        contrastText: alianzaColors.secondary.contrastText,
      },
      // Colores de acento
      success: {
        light: '#81C784',
        main: alianzaColors.accent.green,
        dark: '#388E3C',
        contrastText: '#fff',
      },
      warning: {
        light: '#FFB74D',
        main: alianzaColors.accent.orange,
        dark: '#F57C00',
        contrastText: '#fff',
      },
      info: {
        light: alianzaColors.primary.light,
        main: alianzaColors.primary.main,
        dark: alianzaColors.primary.dark,
        contrastText: '#fff',
      },
      error: {
        light: alianzaColors.secondary.light,
        main: alianzaColors.secondary.main,
        dark: alianzaColors.secondary.dark,
        contrastText: '#fff',
      },
      background: {
        default: alianzaColors.neutral.background,
        paper: alianzaColors.neutral.white,
      },
      text: {
        primary: alianzaColors.neutral.darkGrey,
        secondary: alianzaColors.neutral.mediumGrey,
      },
      // Mantenemos third para compatibilidad legacy
      third: {
        light: '#64d8cb',
        main: '#4caf50',
        dark: '#357a38',
        contrastText: '#fff',
      },
    },
    typography: {
        fontFamily: [
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif',
        ].join(','),
        h1: { fontWeight: 700 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 600 },
        h4: { fontWeight: 600 },
        h5: { fontWeight: 600 },
        h6: { fontWeight: 600 },
        button: { 
          textTransform: 'none',
          fontWeight: 600,
        },
    },
    shape: {
        borderRadius: 12,
    },
    overrides: {
        MuiIconButton: {
          root: {
            padding: 5,
          },
        },
      },
  });

const useStyles = makeStyles({
    root: {
        color: 'rgba(0, 0, 0, 0.87)',
        margin: 0,
        fontSize: '0.875rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 400,
        lineHeight: 1.43,
        letterSpacing: '0.01071em',
        backgroundColor: '#F5F5F5',//'#ffffff', // Establece el color de fondo a blanco
        '& > *': {
            // borderBottom: 'unset',
          //   maxWidth: 345,
          //   display: 'flex',
        },
        '& .Mui-focused .MuiInputLabel-outlined': {
            display: 'none', // Oculta el label cuando el Select está abierto
        },
    //     display: 'flex',
    // flexDirection: 'column',
    // minHeight: '100vh',
    },
    rootRating: {
        display: 'flex',
        alignItems: 'center',
    },
    menu: {
        backgroundColor: 'white', // Establece un fondo opaco para el menú desplegable
        zIndex: 9999, // Asegura que el menú desplegable esté por encima de otros elementos
        // '& .Select-menu-outer': {
        //     zIndex: 'unset', // Anula el z-index definido en la clase .Select-menu-outer
        // },
        '@global .Select-menu-outer': {
            zIndex: '100 !important',
        },
    },
    dialog: {
        zIndex: 10000, // Ajusta el z-index del Dialog para que esté por encima del Select
    },
    paragraph: {
        margin: '8px 0', // Establece el margen superior e inferior del párrafo en 8px
      },
    margin: {
        margin: theme.spacing(1),
    },
    // Card para vista de listadeEventos
    cardContainerLE: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    },
    cardLE: {
        width: '100%', // Ajusta el ancho de la tarjeta según el margen y el espaciado deseado
        backgroundColor: "#f8f9f9",
        // marginBottom: theme.spacing(2),
        position: 'relative',
    },
    cardContentLE: {
        // height: '100%', // Asegura que el contenido de la tarjeta ocupe toda la altura
        // display: 'flex',
        // flexDirection: 'column',
        // justifyContent: 'space-between',
        // maxHeight: 3 * parseFloat(theme.typography.body2.lineHeight), // 3 líneas de texto
        // overflow: 'hidden',
        // position: 'relative',
        // overflow: 'hidden',
        // position: 'relative',
        // maxHeight: '3em', // Altura máxima equivalente a tres líneas de texto
        lineHeight: '1.5em', // Altura de línea
        textOverflow: 'ellipsis', // Añade puntos suspensivos si se recorta el texto
    },
    expandButtonLE: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.8)',
    },
    cardActionsLE: {
        marginTop: 'auto',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    mediaLE: {
        height: 0,
        paddingTop: '56.25%', // 16:9
        // background: 'linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45))',
    },
    text_title_card_LE : {
        fontSize: '16px',
        fontWeight: 600, 
        color: "#494949",   
        marginBottom: 10,
        display: 'flex',
        alignItems: 'center', // Centra verticalmente el icono y el texto
        justifyContent: 'center', // Centra los elementos horizontalmente
        // lineHeight: `${theme.typography.body1.lineHeight * 2}px`, // Doble de la altura de la fuente del body1
    },
    mediaLogin: {
        height: 0,
        paddingTop: '56.25%', // 16:9
        // background: 'linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45))',
    },
    titleContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      },
    cardCustom : {
        backgroundColor: "#f8f9f9",
        marginBottom: 10,
        paddingBottom: 0,
        padding: 0,
        position: 'relative',
        width: '100%',
    },
    
    cardContentCustom:{
        backgroundColor: "#f8f9f9", //#f0f0f0", //"#EAEFF1", //"#FFFFFF",
        marginTop: 0,
        marginBottom: 10,
        paddingBottom: 0,
        paddingTop: 0,
        // maxHeight: 300,
        overflowY: "auto",/* Activa el desplazamiento vertical */
    },
    cardDashboardSettings : {
        backgroundColor: "#f8f9f9",
        marginBottom: 10,
        paddingBottom: 0,
        padding: 10,
        // position: 'relative',
        width: '100%',
        height: '100%',
    },
    cardContentDashboardSettings: {
        display: 'flex',
        justifyContent: 'center',
        // alignItems: 'center',
        // height: '100%',
        backgroundColor: 'white', //"#f8f9f9", //"#0C4A6F", //theme.palette.grey.main, //,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
    },
    cardActionsDashboardSettings: {
        display: 'flex',
        justifyContent: 'center',
    },
    cardLogin : {
        backgroundColor: "#f8f9f9",
        marginBottom: 10,
        paddingBottom: 0,
        padding: 10,
        position: 'relative',
        width: '100%',
        borderRadius: '10px',
    },
    card : {
        backgroundColor: "#f8f9f9",
        marginBottom: 10,
        paddingBottom: 0,
        padding: 10,
        position: 'relative',
        width: '100%',
        // height: '100%',ca
    },
    cardTitle: {
        fontSize: '20px', // Tamaño de fuente deseado
        //fontWeight: 'bold', // Puedes agregar otros estilos aquí si lo deseas
        fontWeight: 600,
        color: "#494949",
        // Otros estilos...
    },
    cardContent:{
        backgroundColor: "#f8f9f9", //#f0f0f0", //"#EAEFF1", //"#FFFFFF",
        marginTop: 0,
        marginBottom: 10,
        paddingBottom: 0,
        // maxHeight: 300,
        overflowY: "auto",/* Activa el desplazamiento vertical */
    },
    cardScroll:{
        backgroundColor: "#f8f9f9", //#f0f0f0", //"#EAEFF1", //"#FFFFFF",
        marginBottom: 10,
        paddingBottom: 10,
        // maxHeight: 300,
        overflowY: "auto",/* Activa el desplazamiento vertical */
        // height: '100%',
    },
    mediaCard: {
        height: 50,
        // height: 200, // Define la altura deseada de la imagen
        objectFit: 'cover', // Ajusta la imagen para llenar el espacio disponible sin deformarla

    },
    linkButton: {
        textTransform: 'none', // Evita que el texto esté en mayúsculas
    },
    cardActions: {
        justifyContent: 'center', // Centra el contenido de CardActions
    },
    addButton: {
        // color: theme.palette.common.white, // Texto blanco
        color: theme.palette.grey.main, // Texto blanco
        backgroundColor: theme.palette.grey.main, // Fondo color primario
        '&:hover': {
          backgroundColor: theme.palette.grey.dark, // Fondo un poco más oscuro al pasar el mouse
        },
        margin: theme.spacing(1), // Margen alrededor del botón para evitar que se pegue a los bordes
    },
    form : {
        marginTop: 10, //20, //40
        marginBottom: 10
    },
    gridmb : {
        marginBottom: 10
    },
    link : {
        display: 'block',
        marginTop: 8,
        fontSize: "1.1rem",
        fontFamily: "Roboto",
        lineHeight: 1.5,
        color: theme.palette.primary.main,
        textDecoration: "none"
    }, 
    avatar : {
        backgroundColor: '#0f80aa',  //0f80aa
        width: 80,
        height: 80
    },
    icon : {
        // fontSize: 60,
        fontSize: 'large',
        marginRight: theme.spacing(1), // Espacio entre el icono y el texto
    },
    containermt : {
        marginTop: 10, //20, //30,
        // backgroundColor: "#EAEFF1",
    },
    containermtLogin : {
        minHeight: '100vh',
        // minHeight: `calc(100vh - ${theme.spacing(11)})`, // theme.spacing(11) devuelve el valor en píxeles
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
        // padding: theme.spacing(2),
        // backgroundImage: `url(${backgroundImage})`,


        marginTop: 0,
        padding: 0,
        // backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh', //`calc(100vh - ${theme.spacing(11)})`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        overflow: "hidden",
    },
    boxLogin : {
        display: 'flex',
        justifyContent: 'center',
        alignItems:'center',
        minHeight: `calc(100vh - ${theme.spacing(11)})`, // theme.spacing(11) devuelve el valor en píxeles
    },
    customContainer: {
        paddingLeft: '0px',
        paddingRight: '0px',
        marginTop: '0px',
    },
    grow : {
        flexGrow: 1,
        // flexGrow: 0,
        // [theme.breakpoints.up('md')]: {
        //     flexGrow: 1
        // }
    },
    appBar : {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: theme.zIndex.drawer + 1, // Asegura que el z-index sea mayor que el del drawer si lo tienes
        paddingTop: 1, //8,
        paddingBottom: 8,
        // Ajustar altura del AppBar si es necesario
        // height: `calc(100% - 20px)`, // Ejemplo: reduce 20px del alto total del AppBar
        // height: 53,
    },
    appBarEC: {
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        // marginRight: theme.spacing(2),
        marginLeft: 'auto',
    },
    hide: {
        display: 'none',
    },
    toolbar: {
        minHeight: '40px !important', // Establecemos una altura mínima para el Toolbar (por ejemplo, 40px)
        [theme.breakpoints.up('sm')]: {
          minHeight: '60px !important', // Ajustamos la altura mínima en pantallas más grandes si es necesario
        },
    },
    content: {
        background: `linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.3)), url(${backgroundImage})`,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    },
    contentFullScreen: {
        background: `linear-gradient(rgba(173, 216, 230, 0.6), rgba(176, 224, 230, 0.8)), url(${backgroundImage})`,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundBlendMode: 'soft-light',
    },
    buttonIcon : {
        fontSize: '14px',
        padding: 0
    },
    iconButton: {
        color: 'white !important', // Esto hace que el IconButton sea blanco
      },
    linkAppBarDesktop : {
        display: "inline-flex",
        alignItems: "center",
        color: "inherit",
        textDecoration: "none",
        padding: "6px 16px"
    },
    linkAppBarMobile : {
        display: "inline-flex",
        alignItems: "center",
        color: "inherit",
        textDecoration: "none",
        width: "100%",
        padding: "8px 16px 8px 16px"
    },
    listItem : {
        padding: 0
    },
    linkAppBarLogo : {
        display: "inline-flex",
        alignItems: "center",
        color: "inherit",
        textDecoration: "none",
    },
    mr : {
        marginRight: 3
    },
    sectionDesktop : {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex'
        }
    },
    sectionMobile : {
        display: 'flex',
        flexGrow: 1,
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    list : {
        width: 250
    },
    listItemIcon : {
        minWidth: 35,
        color: '#84A3B6 !important', //'rgba(0, 0, 0, 0.54)', //'#ffffff', // Color de texto blanco
    },
    media : {  
        height: 250,  
        backgroundColor: "#F2F2F2", 
        // margin: "15px 15px 0 15px" 
    },
    text_card : {
        fontWeight: "bold", 
        color: "#656565",   
        marginBottom: 8    
    },
    price_card : {
        fontWeight: "bold",  
        marginBottom: 5  
    },
    PaperImg : {
        backgroundColor: "#F2F2F2",
    },
    mediaDetalle : {   
        width: 300, /* cambiar de tamaño */
        height: 380,
        margin: "auto",
    },
    text_title : {
        fontSize: '20px',
        fontWeight: 600, 
        color: "#494949",   
        marginBottom: 10,
        display: 'flex',
        alignItems: 'center', // Centra verticalmente el icono y el texto
        justifyContent: 'center', // Centra los elementos horizontalmente
    },
    typographyMargin: {
        marginBottom: theme.spacing(3), // Espacio entre Typography y TextField
    },
    price : {
        float: "right",
        padding: "0 20px 0 20px", 
        backgroundColor: "#0f80aa"
    },
    /* text_title_detalle : {
        fontWeight: 600, 
        color: "#494949",   
        marginBottom: 10
    }, */
    text_detalle : {
        fontWeight: 500, 
        color: "#494949",   
        marginBottom: 5
    },
    
    imgProductoCC : {
        backgroundColor: "#F2F2F2",
        width: 80,
        height: 70
    },
    paperPadding : {
        padding: 20
    },
   
    imgProductoPC : {
        backgroundColor: "#F2F2F2", 
        width: 50, 
        height: 40 
    },
    gridPC : {
        margin: "auto", 
        marginTop: 20 
    },
    divider : {
        marginTop: 12,
        marginBottom: 12 
    },
    dividerRadio : {
        marginTop: 0,
        marginBottom: 4 
    },
    spaceInterlineMin : {
        height: 13
    },
    spaceInterline : {
        height: 15
    },
    spaceInterlineMayor : {
        height: 20
    },
    buttonAnterior : {
        marginRight: 8  
    },
    formControl : {
        /*margin: 12,*/
        margin: theme.spacing(1),
        minWidth: 120   
    },
    gridLR : {
        paddingLeft: 30,  
        paddingRight: 30, 
        paddingBottom: 20 
    },
    
    text_envio : {
        lineHeight: 3 
    },
    alertDelivered : {
        marginTop: 5, 
        padding: "15px 15px 5px 15px", 
        marginBottom: 20, 
        backgroundColor: "#d6f5d6"  
    },
    alertNotDelivered : {
        marginTop: 5, 
        padding: "15px 15px 5px 15px", 
        marginBottom: 20, 
        backgroundColor: "#ffcccc"  
    },
    /*  */
    table : {
        border: "1px solid #e0e0e0" 
    },
    tableCell: {
        paddingLeft: '8px', // Padding izquierdo de 8px
        paddingRight: '8px', // Padding derecho de 8px
    },
    fixColumn: {
        width: 100, // Columnas con ancho fijo
    },
    flexColumn: {
        flexGrow: 1, // Esto permitirá que la tercera columna crezca y ocupe el espacio disponible
    },
    actionColumn: {
        width: 90, // Ajusta el ancho de la columna de botones, 90 si son 2 botones
        textAlign: 'center',
    },

    headerRow: {
        backgroundColor: "#f8f9f9", //theme.palette.secondary.light, // Cambia esto por el color deseado
    },
    typeRow: {
        backgroundColor: "#F1F3F4", //#f8f9f9", //theme.palette.secondary.main, // Cambia esto por otro color, si lo prefieres
    },
    overflowEllipsis: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 120,
      },
    // root: {
    //     '& > *': {
    //       borderBottom: 'unset',
    //     //   maxWidth: 345,
    //     //   display: 'flex',
    //     },
    //   },
    rootAdicional: {
        display: 'flex',
        backgroundColor: "#f8f9f9",
        //   backgroundSize: 'cover', // Ajusta la imagen para llenar el espacio disponible sin deformarla
    },
    cardScrollAdicional:{
        backgroundColor: "#f8f9f9", //#f0f0f0", //"#EAEFF1", //"#FFFFFF",
        // marginBottom: 10,
        // paddingBottom: 10,
        // maxHeight: 300,
        // overflowY: "auto",/* Activa el desplazamiento vertical */
        // height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between', // Alinea los elementos dentro del Card
        height: '100%', // Asegura que la altura del Card sea 100% del contenedor padre
    },
    imageContainerAdicional: {
        display: 'flex',
        alignItems: 'center', // Centra verticalmente el contenido
        justifyContent: 'center', // Centra horizontalmente el contenido
        height: '100%', // Asegura que la altura del contenedor sea igual a la altura del Card
      },
      imageAdicional: {
        maxWidth: '100%', // Ajusta el ancho de la imagen para evitar desbordamientos
        maxHeight: '100%', // Ajusta la altura de la imagen para evitar desbordamientos
      },
      detailsAdicional: {
        display: 'flex',
        flexDirection: 'column',
      },
      contentAdicional: {
        flex: '1 0 auto',
      },
      coverAdicional: {
        // width: 151,
        flex: '1 1 calc(100% / 2)', // El ancho será un tercio del contenedor
        backgroundSize: 'cover', // Ajusta la imagen para llenar el espacio disponible sin deformarla
      },
    //   controls: {
    //     display: 'flex',
    //     alignItems: 'center',
    //     paddingLeft: theme.spacing(1),
    //     paddingBottom: theme.spacing(1),
    //   },
    //   playIcon: {
    //     height: 38,
    //     width: 38,
    //   },
    iconNotDelivered : {
        color: "red", 
        fontWeight: 900 
    },
    iconDelivered : {
        color: "green", 
        fontWeight: 900 
    },
    avatarPefil : { 
        width: 130,
        height: 130,
        backgroundColor: "#0f80aa"
    },
    imageUploader : { 
        padding: 0,
        margin: "-25px auto 15px",
        width: 0
    },
    /* ------ */
    linkMenu : {
        display: "inline-flex", 
        alignItems: "center", 
        color: "inherit", 
        textDecoration: "none", 
        padding: "6px 15px 6px 0", 
        
    },
    mrIcon: {
        marginRight: 10 
    },
    avatarPerfilAppBar : {
        marginRight: 8,   
        backgroundColor: "#F2F2F2" 
    },
    
    listSubItem : {
        padding: "0 0 0 30px !important" 
    },
    listSubItem2 : {
        padding: "0 0 0 60px !important" 
    },
    checkbox : {
        display: "block", 
        padding: 0, 
        marginTop: 5, 
        marginBottom: 5 
    },
    
    buttonAgregar : {
        float : "right"
    },
   
    avatarProducto : {
        // width: '100%', //175, 
        // height: '100%', //175,
        // backgroundColor: "#F2F2F2" ,
        width: '100% !important',
        height: '100% !important',
        backgroundColor: '#F2F2F2 !important',
    },
    selects : {
        fontFamily : "inherited",
    },
    
    // AquÃ­ agregamos nuestro grupo de estilos para react-select
    // selectStyles: {
    //     // Usamos una funciÃ³n para generar un objeto de estilos para react-select
    //     // que serÃ¡ compatible con la prop `styles` de react-select
    //     getStyles: () => ({
    //         menuList: (provided) => ({
    //             ...provided,
    //             maxHeight: 'none', // Establecer maxHeight a 'none' para eliminar la limitaciÃ³n de altura
    //         }),
    //         control: (provided) => ({
    //             ...provided,
    //             fontFamily: theme.typography.fontFamily, // Usa la fuente del tema de Material-UI
    //         }),
    //         // Puedes aÃ±adir mÃ¡s estilos personalizados aquÃ­, siguiendo el mismo patrÃ³n
    //     }),
    // },
    // Directamente como un objeto, no como un mÃ©todo.
    selectStyles: {
        menuList: (provided) => ({
            ...provided,
            maxHeight: 'none', // Establecer maxHeight a 'none'
        }),
        control: (provided) => ({
            ...provided,
            fontFamily: theme.typography.fontFamily,
        }),
        // Agrega mÃ¡s personalizaciones de react-select aquÃ­ si es necesario.
    },
    //tooltips
    tooltip: {
        fontSize: '11px',
      },
    // listitemsecondary en cambiar password de editar usuario
    listItemSecondaryAction: {
        overflow: 'visible !important', // Anula el estilo de overflow predeterminado
        // Otros estilos personalizados segÃºn sea necesario
        width: 'auto', /* Ajusta el ancho automÃ¡ticamente */
        right: 0, /* Alinea el componente a la derecha */
      },
    // AÃ±adiendo estilos adicionales para anular el margen superior
    picker: {
        '& .MuiFormControl-root': {
          marginTop: '0 !important',
          '& .MuiInputBase-root': {
            marginTop: '0 !important',
          },
          '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.75)', // Ajustar segÃºn sea necesario
          }
        },
        '& .MuiFormControl-marginNormal': {
            marginTop: '0 !important',
            '& .MuiInputBase-marginNormal': {
              marginTop: '0 !important',
            },
            '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
              transform: 'translate(14px, -6px) scale(0.75)', // Ajustar segÃºn sea necesario
            }
          }
      },
    // Direct targeting to remove margins
    noMargin: {
    '&.MuiFormControl-root': {
      marginTop: '0 !important',  // Use !important to ensure override
      marginBottom: '0 !important',
    }
    },
    // Estilo global para sobrescribir SweetAlert2
    '@global': {
        '.swal2-popup': {
            'font-family': 'Roboto, sans-serif !important',
        },
        '.swal2-confirm': {
          backgroundColor: theme.palette.primary.main + ' !important', // Color primario para el botón de confirmar
          color: '#fff !important', // Texto blanco para contraste
          '&:hover': {
            backgroundColor: theme.palette.primary.dark + ' !important', // Oscurecer al pasar el ratón por encima
          },
        },
        '.swal2-cancel': {
          backgroundColor: theme.palette.secondary.main + ' !important', // Color secundario para el botón de cancelar
          color: '#fff !important', // Texto blanco para contraste
          '&:hover': {
            backgroundColor: theme.palette.secondary.dark + ' !important', // Oscurecer al pasar el ratón por encima
          },
        },
      },
      // Estilos personalizados para CustomAccordion
    accordionRoot: {
        boxShadow: 'none', // Elimina la sombra
        backgroundColor: 'transparent', // Establece el fondo transparente
        margin: 0, // Elimina el margen
        '& .MuiAccordionSummary-root': {
        minHeight: 'unset', // Elimina el alto mínimo del encabezado
        '& .MuiAccordionSummary-content': {
            margin: 0, // Elimina el margen del contenido
        },
        },
        '& .MuiAccordionSummary-expandIcon': {
        marginRight: 0, // Elimina el margen derecho del icono ExpandMoreIcon
        padding: 8,
        },
    },
    customPaper: {
        marginLeft: 0,
        marginRight: 0,
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        // backgroundColor: theme.palette.primary.main, // Usa el color primario del tema
      },
      
    
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: "#0C4A6F", //theme.palette.primary.main, // Usa el color primario del tema
        color: '#84A3B6',//'rgba(0, 0, 0, 0.54)',//'#ffffff', // Color de texto blanco
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        // justifyContent: 'flex-end',
        justifyContent: 'space-between',
        // padding: theme.spacing(0, 1),
        paddingLeft: theme.spacing(2), // 16px padding left
        paddingRight: theme.spacing(1), // 8px padding right,
        // backgroundColor: "#ffffff",
    },
    drawerHeaderLogo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(2),
        color: 'white', // Color del texto blanco
        flexDirection: 'column', // Alinea verticalmente el contenido
        marginTop: '16px', // Margen superior de 16 píxeles
    },
    drawerHeaderLogin: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // padding: theme.spacing(2),
        // color: 'white', // Color del texto blanco
        flexDirection: 'column', // Alinea verticalmente el contenido
        // marginTop: '16px', // Margen superior de 16 píxeles
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginRight: theme.spacing(2),
      },
      title: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
      },
      version: {
        fontSize: '0.75rem',
      },
    logo: {
        width: '180px',//'180px',
        height: 'auto', // Mantiene la proporción de la imagen
    },
    logoLogin: {
        maxWidth: '200px',
        maxHeight: '200px',
        width: 'auto',
        height: 'auto',
        objectFit: 'contain',
        marginBottom: '16px',
        filter: 'drop-shadow(0 2px 8px rgba(0, 0, 0, 0.1))',
        [theme.breakpoints.down('xs')]: {
            maxWidth: '150px',
            maxHeight: '150px',
        },
    },
    cameraContainer: {
        position: 'relative',
    },
    cameraOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none', // Para que los clics pasen a través de la superposición
    },
    cameraOverlayInner: {
        width: '80%',
        height: '80%',
        border: '2px solid red', // Puedes cambiar el color y el estilo del borde
        boxSizing: 'border-box',
        pointerEvents: 'none', // Para que los clics pasen a través de la superposición
    },
    // search
    rootSearch: {
        flexGrow: 1,
      },
      menuButtonSearch: {
        marginRight: theme.spacing(2),
      },
      titleSearch: {
        flexGrow: 1,
        display: 'none',
        [theme.breakpoints.up('sm')]: {
          display: 'block',
        },
      },
      search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
          backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          marginLeft: theme.spacing(1),
          width: 'auto',
        },
        display: 'flex', // Para asegurar que los elementos internos estén en línea
        alignItems: 'center', // Para alinear verticalmente los elementos
      },
      searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      inputRoot: {
        color: 'inherit',
        width: '100%',
      },
      inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          width: '12ch',
          '&:focus': {
            width: '20ch',
          },
        },
      },
      searchContainer: {
        position: 'relative',
        display: 'flex', // Para asegurar que los elementos internos estén en línea
    alignItems: 'center', // Para alinear verticalmente los elementos
      },

    // SelectEstadoevento
    timeline: {
        // transform: "rotate(90deg)",
      display: 'flex',
      flexDirection: 'row',
      padding: '0px 0',
      margin: '0',
    },
    timelineItem: {
      flex: 1,
    //   display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minWidth: '30px',
      '&::before': {
        display: 'none',
      },
      minHeight: '0px',
    },
    timelineSeparator: {
        display: 'flex',
        flexDirection: 'column',//'row',
        alignItems: 'center',
        minHeight: '20px',
    //   flexDirection: 'row',
    //   alignItems: 'center',
    //   '& > *': {
    //     margin: '2px',
    //   },
    },
    timelineConnector: {
        width: '100%',
        height: '2px',
        backgroundColor: 'gray',
        flexGrow: 1,
        // width: '100%',
        // flexGrow: 1,
        // height: '2px',
        // backgroundColor: 'white',
      },
    timelineDot: {
      width: '10px',
      height: '10px',
    },
    redDot: {
      backgroundColor: 'red',
    },
    timelineContent: {
        display: "inline-block",
      padding: '2px 0',
      fontSize: '11px',
      textAlign: 'center',
    },
    collapseContainer: {
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[4],
        borderRadius: theme.shape.borderRadius,
    },
    // fin selectEstadoEvento

    cardContentTyC: {
        maxHeight: 400, /* Ajusta el alto según tus necesidades */
        overflowY: 'auto',
    },


    //alianza
    // En tu useStyles.js, agrega esto dentro de makeStyles({})
    primaryButton: {
        backgroundColor: alianzaColors.primary.main,
        color: alianzaColors.neutral.white,
        '&:hover': {
            backgroundColor: alianzaColors.primary.dark,
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(30, 136, 229, 0.3)'
        },
        width: '100%',
        padding: '12px 0',
        border: 'none',
        borderRadius: '12px',
        cursor: 'pointer',
        fontSize: '16px',
        boxShadow: '0 2px 8px rgba(30, 136, 229, 0.2)',
        transition: 'all 0.3s ease',
        fontWeight: 600,
    },

    // ============================================
    // NUEVOS ESTILOS ALIANZA SOCIAL
    // ============================================
    
    // BOTONES ALIANZA SOCIAL
    primaryButtonAlianza: {
        backgroundColor: alianzaColors.primary.main,
        color: alianzaColors.neutral.white,
        '&:hover': {
            backgroundColor: alianzaColors.primary.dark,
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(30, 136, 229, 0.3)',
        },
        width: '100%',
        padding: '12px 0',
        border: 'none',
        borderRadius: '12px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 600,
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 8px rgba(30, 136, 229, 0.2)',
    },
    
    secondaryButtonAlianza: {
        backgroundColor: alianzaColors.secondary.main,
        color: alianzaColors.neutral.white,
        '&:hover': {
            backgroundColor: alianzaColors.secondary.dark,
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(230, 57, 70, 0.3)',
        },
        width: '100%',
        padding: '12px 0',
        border: 'none',
        borderRadius: '12px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 600,
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 8px rgba(230, 57, 70, 0.2)',
    },
    
    successButtonAlianza: {
        backgroundColor: alianzaColors.accent.green,
        color: alianzaColors.neutral.white,
        '&:hover': {
            backgroundColor: '#388E3C',
            transform: 'translateY(-2px)',
        },
        width: '100%',
        padding: '12px 0',
        border: 'none',
        borderRadius: '12px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 600,
        transition: 'all 0.3s ease',
    },
    
    outlinedButtonAlianza: {
        background: 'transparent',
        color: alianzaColors.primary.main,
        border: `2px solid ${alianzaColors.primary.main}`,
        '&:hover': {
            backgroundColor: 'rgba(30, 136, 229, 0.08)',
            borderColor: alianzaColors.primary.dark,
        },
        width: '100%',
        padding: '10px 0',
        borderRadius: '12px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 600,
        transition: 'all 0.3s ease',
    },
    
    // CARDS ALIANZA SOCIAL
    cardAlianza: {
        backgroundColor: alianzaColors.neutral.white,
        borderRadius: '16px',
        padding: '24px',
        marginBottom: '16px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        transition: 'all 0.3s ease',
        border: `1px solid rgba(30, 136, 229, 0.1)`,
        width: '100%',
        '&:hover': {
            boxShadow: '0 4px 16px rgba(30, 136, 229, 0.15)',
            transform: 'translateY(-4px)',
        },
    },
    
    cardPrimaryAlianza: {
        backgroundColor: alianzaColors.neutral.white,
        borderRadius: '16px',
        padding: '24px',
        marginBottom: '16px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        transition: 'all 0.3s ease',
        borderLeft: `6px solid ${alianzaColors.primary.main}`,
        width: '100%',
        '&:hover': {
            boxShadow: '0 4px 16px rgba(30, 136, 229, 0.15)',
            transform: 'translateY(-4px)',
        },
    },
    
    cardSecondaryAlianza: {
        backgroundColor: alianzaColors.neutral.white,
        borderRadius: '16px',
        padding: '24px',
        marginBottom: '16px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        transition: 'all 0.3s ease',
        borderLeft: `6px solid ${alianzaColors.secondary.main}`,
        width: '100%',
        '&:hover': {
            boxShadow: '0 4px 16px rgba(230, 57, 70, 0.15)',
            transform: 'translateY(-4px)',
        },
    },
    
    cardLoginAlianza: {
        // backgroundColor: alianzaColors.neutral.white,
        backgroundColor: 'rgba(255, 255, 255, 0.85)',  // ✅ 35% opaco
        backdropFilter: 'blur(10px)',                  // ✅ Efecto blur
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.38)',   // ✅ Sombra 38%
        borderRadius: '20px',
        padding: '32px',
        // boxShadow: '0 8px 32px rgba(30, 136, 229, 0.12)',
        maxWidth: '450px',
        margin: '0 auto',
        border: `1px solid rgba(30, 136, 229, 0.1)`,
    },
    
    // INPUTS ALIANZA SOCIAL
    inputAlianza: {
        width: '100%',
        padding: '14px 18px',
        borderRadius: '12px',
        border: `2px solid rgba(30, 136, 229, 0.2)`,
        fontSize: '16px',
        fontFamily: '"Roboto", sans-serif',
        transition: 'all 0.3s ease',
        backgroundColor: alianzaColors.neutral.white,
        outline: 'none',
        '&:focus': {
            borderColor: alianzaColors.primary.main,
            boxShadow: `0 0 0 4px rgba(30, 136, 229, 0.1)`,
        },
        '&::placeholder': {
            color: alianzaColors.neutral.mediumGrey,
        },
    },
    
    formLabelAlianza: {
        display: 'block',
        fontSize: '14px',
        fontWeight: 600,
        color: alianzaColors.neutral.darkGrey,
        marginBottom: '8px',
        marginTop: '16px',
    },
    
    // TABLAS ALIANZA SOCIAL
    tableAlianza: {
        width: '100%',
        backgroundColor: alianzaColors.neutral.white,
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    },
    
    tableHeaderAlianza: {
        backgroundColor: 'rgba(30, 136, 229, 0.08)',
        '& th': {
            padding: '16px 20px',
            fontSize: '14px',
            fontWeight: 700,
            color: alianzaColors.primary.dark,
            textAlign: 'left',
            borderBottom: `2px solid ${alianzaColors.primary.main}`,
        },
    },
    
    tableRowAlianza: {
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: 'rgba(30, 136, 229, 0.04)',
        },
        '& td': {
            padding: '14px 20px',
            fontSize: '15px',
            color: alianzaColors.neutral.darkGrey,
            borderBottom: `1px solid rgba(189, 189, 189, 0.5)`,
        },
    },
    
    // BADGES ALIANZA SOCIAL
    badgePrimaryAlianza: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '6px 14px',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: 600,
        backgroundColor: 'rgba(30, 136, 229, 0.15)',
        color: alianzaColors.primary.dark,
    },
    
    badgeSecondaryAlianza: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '6px 14px',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: 600,
        backgroundColor: 'rgba(230, 57, 70, 0.15)',
        color: alianzaColors.secondary.dark,
    },
    
    badgeSuccessAlianza: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '6px 14px',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: 600,
        backgroundColor: 'rgba(76, 175, 80, 0.15)',
        color: '#2E7D32',
    },
    
    // ESTILOS ADICIONALES PARA REGISTER
    formGroup: {
        marginBottom: '20px',
    },
    
    inputError: {
        width: '100%',
        padding: '14px 18px',
        borderRadius: '12px',
        border: '2px solid #E63946',
        fontSize: '16px',
        fontFamily: '"Roboto", sans-serif',
        transition: 'all 0.3s ease',
        backgroundColor: 'rgba(230, 57, 70, 0.05)',
        outline: 'none',
        '&:focus': {
            borderColor: '#C62828',
            boxShadow: '0 0 0 4px rgba(230, 57, 70, 0.1)',
        },
    },
    
    errorMessage: {
        color: '#C62828',
        fontSize: '13px',
        marginTop: '6px',
        display: 'block',
        fontWeight: 500,
    },

    // ════════════════════════════════════════════════════════════════
    // ═══════════════ ESTILOS TEMA CAPELLANES ════════════════════════
    // ════════════════════════════════════════════════════════════════

    // CONTENEDOR PRINCIPAL - FONDO OSCURO
    capellanesContainer: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${capellanesColors.black} 0%, ${capellanesColors.darkGrey} 50%, #3D3D3D 100%)`,
        position: 'relative',
        overflow: 'hidden',
        padding: '16px',
    },

    // OVERLAY DECORATIVO
    capellanesOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `
            radial-gradient(circle at 20% 80%, rgba(212, 175, 55, 0.15) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(212, 175, 55, 0.1) 0%, transparent 40%)
        `,
        pointerEvents: 'none',
    },

    // CÍRCULOS DECORATIVOS ANIMADOS
    capellanesCircleLarge: {
        position: 'absolute',
        width: '150px',
        height: '150px',
        border: `1px solid rgba(212, 175, 55, 0.2)`,
        borderRadius: '50%',
        animation: '$float 8s ease-in-out infinite',
    },

    capellanesCircleMedium: {
        position: 'absolute',
        width: '100px',
        height: '100px',
        border: `1px solid rgba(212, 175, 55, 0.3)`,
        borderRadius: '50%',
        animation: '$float 6s ease-in-out infinite 1s',
    },

    capellanesCircleSmall: {
        position: 'absolute',
        width: '80px',
        height: '80px',
        border: `1px solid rgba(212, 175, 55, 0.25)`,
        borderRadius: '50%',
        animation: '$float 5s ease-in-out infinite 0.5s',
    },

    // CARD PRINCIPAL CAPELLANES
    capellanesCard: {
        position: 'relative',
        zIndex: 1,
        width: '100%',
        maxWidth: '450px',
        borderRadius: '16px',
        overflow: 'hidden',
        border: `2px solid rgba(212, 175, 55, 0.5)`,
        background: `linear-gradient(180deg, ${capellanesColors.darkGrey}F0 0%, ${capellanesColors.black}F5 100%)`,
        backdropFilter: 'blur(20px)',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
    },

    // CARD GRANDE (para registro)
    capellanesCardLarge: {
        position: 'relative',
        zIndex: 1,
        width: '100%',
        maxWidth: '1100px',
        borderRadius: '16px',
        overflow: 'hidden',
        border: `2px solid rgba(212, 175, 55, 0.5)`,
        display: 'flex',
        flexDirection: 'row',
        minHeight: '700px',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            minHeight: 'auto',
        },
    },

    // HEADER DORADO
    capellanesHeader: {
        background: `linear-gradient(135deg, ${capellanesColors.gold} 0%, ${capellanesColors.darkGold} 100%)`,
        padding: '32px 24px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
    },

    capellanesHeaderShine: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `radial-gradient(circle at 50% 0%, rgba(255,255,255,0.2) 0%, transparent 50%)`,
        pointerEvents: 'none',
    },

    // HEADER DE ERROR (para SinConexion)
    capellanesHeaderError: {
        background: `linear-gradient(135deg, ${capellanesColors.error}90 0%, #B71C1C 100%)`,
        padding: '32px 24px',
        textAlign: 'center',
        position: 'relative',
    },

    // LOGO EN HEADER
    capellanesLogo: {
        width: '100px',
        height: '100px',
        objectFit: 'contain',
        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
        marginBottom: '16px',
        borderRadius: '50%',
        border: `3px solid rgba(26, 26, 26, 0.3)`,
    },

    // PANEL LATERAL DORADO (para registro)
    capellanesSidePanel: {
        flex: '0 0 40%',
        background: `linear-gradient(135deg, ${capellanesColors.gold} 0%, ${capellanesColors.darkGold} 100%)`,
        padding: '40px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            flex: 'none',
            padding: '24px',
        },
    },

    // PANEL DE FORMULARIO OSCURO
    capellanesFormPanel: {
        flex: 1,
        background: `linear-gradient(180deg, ${capellanesColors.darkGrey}F5 0%, ${capellanesColors.black}F8 100%)`,
        padding: '32px',
        overflowY: 'auto',
        [theme.breakpoints.down('md')]: {
            padding: '24px',
        },
    },

    // TÍTULO DORADO
    capellanesTitle: {
        fontWeight: 700,
        color: capellanesColors.black,
        marginBottom: '8px',
        textShadow: '0 1px 2px rgba(255,255,255,0.2)',
    },

    capellanesTitleLight: {
        fontWeight: 700,
        color: capellanesColors.gold,
        marginBottom: '8px',
    },

    // SUBTÍTULO
    capellanesSubtitle: {
        color: capellanesColors.darkGrey,
        fontSize: '0.9rem',
        fontWeight: 500,
    },

    capellanesSubtitleLight: {
        color: capellanesColors.lightGold,
        fontSize: '0.9rem',
    },

    // CONTENIDO DEL FORMULARIO
    capellanesContent: {
        padding: '32px',
    },

    // ALERT DE ERROR
    capellanesAlertError: {
        padding: '16px',
        marginBottom: '24px',
        backgroundColor: `rgba(230, 57, 70, 0.15)`,
        border: `1px solid ${capellanesColors.error}`,
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },

    capellanesAlertText: {
        color: capellanesColors.error,
        fontSize: '0.9rem',
    },

    // BOTÓN DORADO PRINCIPAL
    capellanesButtonPrimary: {
        width: '100%',
        padding: '12px 32px',
        backgroundColor: capellanesColors.gold,
        color: capellanesColors.black,
        border: 'none',
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: 700,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        transition: 'all 0.3s ease',
        boxShadow: `0 4px 20px rgba(212, 175, 55, 0.4)`,
        '&:hover': {
            backgroundColor: capellanesColors.darkGold,
            transform: 'translateY(-2px)',
            boxShadow: `0 6px 24px rgba(212, 175, 55, 0.5)`,
        },
        '&:disabled': {
            opacity: 0.7,
            cursor: 'not-allowed',
            transform: 'none',
        },
    },

    // BOTÓN DORADO OUTLINED
    capellanesButtonOutlined: {
        width: '100%',
        padding: '12px 32px',
        backgroundColor: 'transparent',
        color: capellanesColors.gold,
        border: `2px solid ${capellanesColors.gold}`,
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: 600,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: `rgba(212, 175, 55, 0.15)`,
            transform: 'translateY(-2px)',
        },
    },

    // BOTÓN OSCURO
    capellanesButtonDark: {
        padding: '12px 32px',
        backgroundColor: capellanesColors.black,
        color: capellanesColors.gold,
        border: 'none',
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: 700,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: capellanesColors.darkGrey,
            transform: 'scale(1.02)',
        },
    },

    // TEXTFIELD CAPELLANES (para usar con sx prop)
    // Los estilos de TextField se aplican mediante sx, no className

    // DIVIDER DORADO
    capellanesDivider: {
        display: 'flex',
        alignItems: 'center',
        margin: '24px 0',
        gap: '16px',
    },

    capellanesDividerLine: {
        flex: 1,
        height: '1px',
        backgroundColor: `rgba(212, 175, 55, 0.3)`,
    },

    capellanesDividerText: {
        color: capellanesColors.lightGold,
        fontSize: '0.85rem',
    },

    // LINK DORADO
    capellanesLink: {
        color: capellanesColors.lightGold,
        fontSize: '0.9rem',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        transition: 'all 0.3s ease',
        textDecoration: 'none',
        '&:hover': {
            color: capellanesColors.gold,
        },
    },

    capellanesLinkGold: {
        color: capellanesColors.gold,
        fontWeight: 600,
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
        },
    },

    // CHECKBOX CAPELLANES
    capellanesCheckboxContainer: {
        padding: '16px',
        backgroundColor: `rgba(212, 175, 55, 0.1)`,
        borderRadius: '8px',
        border: `1px solid rgba(212, 175, 55, 0.3)`,
        marginBottom: '24px',
    },

    capellanesCheckboxContainerError: {
        padding: '16px',
        backgroundColor: `rgba(212, 175, 55, 0.1)`,
        borderRadius: '8px',
        border: `2px solid ${capellanesColors.error}`,
        marginBottom: '24px',
    },

    // PAPER INFO (beneficios, consejos)
    capellanesPaperInfo: {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        borderRadius: '12px',
        padding: '24px',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(0, 0, 0, 0.1)',
    },

    capellanesPaperInfoDark: {
        backgroundColor: 'rgba(255, 255, 255, 0.03)',
        borderRadius: '12px',
        padding: '24px',
        border: `1px solid rgba(212, 175, 55, 0.2)`,
    },

    // CONTADOR (para SinConexion)
    capellanesCounterContainer: {
        padding: '24px',
        backgroundColor: `rgba(212, 175, 55, 0.1)`,
        border: `2px solid rgba(212, 175, 55, 0.4)`,
        borderRadius: '12px',
        textAlign: 'center',
        marginBottom: '32px',
    },

    capellanesCounterCircle: {
        width: '70px',
        height: '70px',
        borderRadius: '50%',
        border: `3px solid ${capellanesColors.gold}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 16px',
    },

    capellanesCounterNumber: {
        color: capellanesColors.gold,
        fontWeight: 800,
        fontSize: '2.5rem',
    },

    // MODAL CAPELLANES
    capellanesModalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '16px',
    },

    capellanesModal: {
        maxWidth: '900px',
        width: '100%',
        maxHeight: '90vh',
        borderRadius: '16px',
        border: `2px solid ${capellanesColors.gold}`,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },

    capellanesModalHeader: {
        backgroundColor: capellanesColors.gold,
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },

    capellanesModalFooter: {
        padding: '16px',
        backgroundColor: capellanesColors.offWhite,
    },

    // CELEBRACIÓN
    capellanesCelebration: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99998,
    },

    capellanesCelebrationCard: {
        backgroundColor: capellanesColors.offWhite,
        borderRadius: '16px',
        padding: '48px',
        maxWidth: '500px',
        textAlign: 'center',
        border: `3px solid ${capellanesColors.gold}`,
        animation: '$scaleIn 0.5s ease-out',
    },

    // FOOTER BRANDING
    capellanesFooter: {
        padding: '16px',
        textAlign: 'center',
        borderTop: `1px solid rgba(212, 175, 55, 0.2)`,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
    },

    capellanesFooterText: {
        color: `rgba(244, 228, 188, 0.5)`,
        fontSize: '0.8rem',
    },

    // CHIP DORADO
    capellanesChip: {
        backgroundColor: capellanesColors.gold,
        color: capellanesColors.black,
        fontWeight: 600,
        padding: '8px 4px',
        fontSize: '1rem',
    },

    // ICONO EN CÍRCULO
    capellanesIconCircle: {
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 16px',
        animation: '$pulse 2s infinite',
    },

    // ANIMACIONES KEYFRAMES
    '@keyframes float': {
        '0%, 100%': { transform: 'translateY(0px)' },
        '50%': { transform: 'translateY(-15px)' },
    },

    '@keyframes pulse': {
        '0%, 100%': { transform: 'scale(1)', opacity: 1 },
        '50%': { transform: 'scale(1.05)', opacity: 0.9 },
    },

    '@keyframes fadeIn': {
        from: { opacity: 0, transform: 'scale(0.95)' },
        to: { opacity: 1, transform: 'scale(1)' },
    },

    '@keyframes scaleIn': {
        '0%': { transform: 'scale(0.5)', opacity: 0 },
        '100%': { transform: 'scale(1)', opacity: 1 },
    },

    '@keyframes bounce': {
        '0%, 100%': { transform: 'translateY(0)' },
        '50%': { transform: 'translateY(-20px)' },
    },

    '@keyframes confettiFall': {
        '0%': { transform: 'translateY(-20px) rotateZ(0deg)', opacity: 1 },
        '100%': { transform: 'translateY(100vh) rotateZ(720deg)', opacity: 0 },
    },
});

export default useStyles;

export { theme, alianzaColors, capellanesColors };